// Cart-line identity for presentations.
//
// A product can appear in a presentation more than once — the same blank in two
// colors, or with two different prints. So each cart line needs its own id. The
// FIRST copy of a product keeps the product's own id (backward-compatible with
// saved presentations); any additional copy gets a unique instance id
// ("<productId>::<suffix>"). `_baseId` always holds the real product id, which is
// what pricing, inventory, and search lookups use.

export function baseProductId(p) {
  return (p && (p._baseId || p.id)) || '';
}

// Return the product with an appropriate cart-line id + _baseId, given the
// current cart. Does not mutate the input.
export function assignCartLineId(cart, product) {
  const baseId = product._baseId || product.id;
  const dup = (cart || []).some(p => baseProductId(p) === baseId);
  const id = dup
    ? `${baseId}::${Date.now().toString(36)}${Math.random().toString(36).slice(2, 6)}`
    : baseId;
  return { ...product, id, _baseId: baseId };
}
